import React from 'react';
import * as Icon from 'react-feather';
const navigationConfig = [
  {
    id: 'home',
    title: 'Kalendář',
    type: 'item',
    icon: <Icon.Calendar size={20} />,
    permissions: ['admin', 'editor'],
    navLink: '/',
  },
  {
    id: 'page2',
    title: 'Statistiky',
    type: 'item',
    icon: <Icon.Trello size={20} />,
    permissions: ['admin', 'editor'],
    navLink: '/page2',
  },
];

export default navigationConfig;
